import { makeRivieraDataQueryPackage } from 'js/file_viewer/core/queries/riviera_base';
import { rivieraClient } from 'js/file_viewer/core/riviera/api';
const fetchTextData = async (args) => {
    var _a;
    const content = (_a = args.previewMetadata) === null || _a === void 0 ? void 0 : _a.content;
    if ((content === null || content === void 0 ? void 0 : content['.tag']) !== 'text' || !(content === null || content === void 0 ? void 0 : content.extracted_text)) {
        throw new Error('Invalid preview metadata provided for text preview');
    }
    const result = await rivieraClient.fetchTextContent(content.extracted_text);
    if (result.error) {
        throw result.error;
    }
    return result.data;
};
const textQueryPackage = makeRivieraDataQueryPackage({
    fileTypeSpecificQueryFn: fetchTextData,
    fieldName: 'extracted_text',
});
export const prefetchTextRivieraData = (queryClient, previewKey, previewMetadata) => {
    const content = previewMetadata === null || previewMetadata === void 0 ? void 0 : previewMetadata.content;
    if ((content === null || content === void 0 ? void 0 : content['.tag']) !== 'text') {
        return Promise.resolve();
    }
    return textQueryPackage.prefetchQuery(queryClient, {
        apiArg: {
            previewKey,
            previewMetadata,
        },
        pkgArg: null,
    });
};
export const useTextDataQuery = (previewKey, previewMetadata) => {
    const content = previewMetadata === null || previewMetadata === void 0 ? void 0 : previewMetadata.content;
    const isText = (content === null || content === void 0 ? void 0 : content['.tag']) === 'text';
    return textQueryPackage.useQuery({
        apiArg: {
            previewKey,
            previewMetadata,
        },
        pkgArg: null,
    }, {
        enabled: !!previewKey && isText,
        retry: true,
    });
};
//# sourceMappingURL=text.preenvesnextjs.map
